import React from "react";
import ExcelJS from "exceljs";
import { DownloadOutlined } from "@ant-design/icons";
import { Card, CardBody, CardHeader } from "reactstrap";
import { Tag } from "antd";
import { Bs1Circle } from "react-icons/bs";


const DownloadExcelModel = () => {
  const downloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Plusieurs utilisateurs");

    worksheet.getCell('A1').value = "Prenom et Nom";
    worksheet.getCell('B1').value = "Adresse email";
    worksheet.getCell('C1').value = "Téléphone";
    worksheet.getCell('D1').value = "Adresse";
    worksheet.getCell('E1').value = "Numéro permis";

    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = { horizontal: "center" };

    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '1F5357' }
      };
      cell.font = { bold: true, color: { argb: 'FFFFFF' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    worksheet.getColumn('A').width = 20;
    worksheet.getColumn('B').width = 20;
    worksheet.getColumn('C').width = 20;
    worksheet.getColumn('D').width = 20;
    worksheet.getColumn('E').width = 20;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "modele_chauffeurs_en_masse.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Card className="card-animate">
      <CardHeader className="card-header">
        <h4 className="card-title mb-0"><Bs1Circle /> Modèle Excel à télécharger</h4>
      </CardHeader>
      <CardBody>
        <p className="text-muted text-center">
          Téléchargez le modèle Excel et remplissez-le avec les données appropriées.
        </p>
        <div className="dropzone dz-clickable text-center" onClick={downloadExcel}>
          <div className="dz-message needsclick">
            <div className="mb-3">
              <i className="display-4 text-muted ri-download-cloud-2-fill" />
            </div>
            <h6>Télécharger le modèle</h6>
            <div>
              <Tag color="cyan" title="Le nom du modèle">
                <DownloadOutlined /> modele_chauffeurs_en_masse.xlsx
              </Tag>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DownloadExcelModel;
